const page= (data,body)=>{
var tags='';
data.tags.map(e=>{
    if(e.customOption)
        e=e.etiqueta
    tags+='<a href="#"><span class="px-2">#'+e.etiqueta+'</span></a>';
})

var fecha = '';
if(data.fecha!==null){
    fecha=data.fecha.toLocaleDateString('es',{ day:'2-digit',month: 'short', year: '2-digit' }).replace('. ',' \'');
    fecha=fecha.slice(0,3)+fecha.charAt(3).toUpperCase()+  fecha.slice(4);
}

let categoria = data.categoria[0].nombre || ''

return(
`
<!DOCTYPE html>
<html lang="en">
<head>
	<meta charset="utf-8">
	<meta http-equiv="X-UA-Compatible" content="IE=edge">
	<meta name="viewport" content="width=device-width, initial-scale=1.0">
	<title>${data.titulo}</title>
	<meta name="theme-color" content="#0c1868">
	<link rel="icon" href="/preview/favicon.png">
	<meta name="robots" content="noindex,nofollow">
	<link rel="stylesheet" type="text/css" href="/preview/assets/css/bootstrap.min.css">
    <link rel="stylesheet" type="text/css" href="/preview/assets/css/slick.min.css">
    <link rel="stylesheet" type="text/css" href="/preview/assets/fonts/css/icons-jaktur.css"> 
    <link rel="stylesheet" type="text/css" href="/preview/assets/css/slick-theme.min.css">  
    <link rel="stylesheet" type="text/css" href="/preview/assets/js/dist/css/lightgallery.css"> 
    <link rel="stylesheet" type="text/css" href="/preview/assets/css/estilo.css"> 
    <link rel="stylesheet" type="text/css" href="/preview/assets/css/select2.min.css">
    <!--<script src="/preview/assets/js/jquery-3.5.1.min.js"></script>	
    <script src="/preview/assets/js/popper.min.js"></script>	
    <script src="/preview/assets/js/bootstrap.min.js"></script>	
    <script src="/preview/assets/js/bootstrap.bundle.min.js"></script>	 
    <script src="/preview/assets/js/dist/js/picturefill.min.js"></script>
    <script src="/preview/assets/js/dist/js/lightgallery.js"></script>
    <script src="/preview/assets/js/dist/js/lg-fullscreen.js"></script>
    <script src="/preview/assets/js/dist/js/lg-zoom.js"></script>
    <script src="/preview/assets/js/slick.js"></script> 
    <script src="/preview/assets/js/fresco.min.js"></script> 
    <script src="/preview/assets/js/select2.full.min.js"></script> 
    <script src="/preview/assets/js/mdb-file-upload.min.js"></script> 
    <script src="/preview/assets/js/scripts.js"></script>-->	
</head>
<body>

    <head>   
    <!-- Navegación-->
    <nav class="navbar navbar-expand-lg navbar-blue fixed-top">
        <div class="container-fluid"> 
            <!--<a class="navbar-brand" href="#"><img src="/preview/assets/imagenes/LOGO-GRUPO-JAKTUR.png" title="Logo Grupo Jaktur"></a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"><img class="icon-32" src="/preview/assets/imagenes/icon/menu-24px.svg"></span>
            </button>-->
            <div class="collapse navbar-collapse" id="navbarResponsive">
                <div class="container px-0 py-3">
                    <div class="row md-menu-cabecera">
                        <div class="menuI">
                            <ul class="navbar-nav ml-auto">
                                <li class="nav-item">
                                    <a class="nav-link" href="#">Nosotros</a>
                                </li>
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="#" role="button" aria-haspopup="true" aria-expanded="false">Unidades de negocios +</a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#">Church's Chicken</a>
                                        <a class="dropdown-item" href="#">Papa John's</a>
                                        <a class="dropdown-item" href="#">Daytona Beach Car Wash</a>
                                        <a class="dropdown-item" href="#">XS Gym</a>
                                        <a class="dropdown-item" href="#">Hoku</a>
                                        <a class="dropdown-item" href="#">ecoclean</a>
                                        <a class="dropdown-item" href="#">Simplemente Deli</a>
                                        <a class="dropdown-item" href="#">Plaza Pirámide</a>
                                    </div>
                                    
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">Noticias</a>
                                </li>  
                            </ul>
                        </div>
                        <div class="logo-navbar">
                            <a href="#"><img src="/preview/assets/imagenes/LOGO-GRUPO-JAKTUR.png" title="Grupo Jaktur" alt="Grupo Jaktur" ></a>
                        </div>
                        <div class="menuD">
                            <ul class="navbar-nav ml-auto">
                                <li class="nav-item">
                                    <a class="nav-link" href="#">Blog</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">Contacto</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#" >Facturación</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">Bolsa de trabajo</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="nav-rrss text-center mb-3">
                    <p class="text-center text-light">¡Síguenos!</p>
                    <span> <a href="#"><i class="icon-jaktur icon-jaktur-facebook-f px-2"></i></a> <a href="#"><i class="icon-jaktur icon-jaktur-twitter px-2"></i></a> <a href="#"><i class="icon-jaktur icon-jaktur-instagram px-2"></i></a> <a href="#"><i class="icon-jaktur icon-jaktur-linkedin px-2"></i></a></span>
                </div>
            </div>
        </div>
    </nav>
    </head>
	
	<!--Cabecera-->
	<header class="paginaNoticias tituloPagina">
		<div class="container-fluid background-AzulCeleste">
			<div class="row">
				<div class="col-md-8 text-center offset-md-2">
					<h1 class="titulo">${data.titulo}</h1>  
				</div>
			</div>
		</div>
	</header>
	
	<main class="container-fluid paginaPost fullAncho overflow-hidden">
		<div class="row wrapper">   
			<!--Cuerpo-->     
			<div class="col-12 col-lg-8 order-1 order-lg-2">
				<article class="cuerpo">      
					<div class="postImagen" >
						<img class="imagen img-fluid efectBrightness-1" src="${data.portada.base}" alt="">
					</div>                     
					<div class="info-post">                
						<span class="post-fecha">${fecha} | <span class="categoría"><a href="#">${categoria}</a></span></span>
						<blockquote class="cita">${data.introduccion}</blockquote >
						</div>
						<div class="container-fluid overflow-hidden">
							<div class="row">
								<div class="col-12">
									<div class="post">
                                        ${body}
                                        ${data.autor!=''? '<p>Autor: <strong>'+data.autor+'</strong></p>':''}  
                                        ${data.fuente!=''? '<p>Fuente: <strong>'+data.fuente+'</strong></p>':''}                                                                  
									</div>
								</div>
							</div>                     
						</article>
                        <div class="etiquetas">
                            ${tags}
                        </div>
						
						
					</div>                     
					<!--Sidebar-->
					<aside class="col-12 col-lg-4 col-xl-3 order-3 order-lg-1 sidebar mx-auto">
						<div class="search principal pb-5">
							<div class="input-group">
								<input class="form-control" type="text" placeholder="Buscar noticias..." aria-label="Search">
								<div class="input-group-append">
									<span class="input-group-text" id="submit-busqueda"><i class="icon-jaktur icon-jaktur-search-oscuro" aria-hidden="true"></i></span>
								</div>
							</div>
						</div>
						<div class="categoriasSidebar">
							<div class="title">
								<i class="icon-jaktur icon-jaktur-list"  aria-hidden="true"></i><span>Categorías</span>
							</div>
							<div class="listaCategorias">
								<ul>
									<li><a href="#">Comunicado</a> </li>
									<li><a href="#">Entrevistas</a> </li>
									<li><a href="#">Noticias</a> </li>
								</ul>
							</div>
						</div>
						<div class="categoriasEtiquetasSidebar">
							<div class="title">
								<span><i class="icon-jaktur icon-jaktur-etiqueta"  aria-hidden="true"></i>Etiquetas</span>
							</div>
							<div class="tags">
								
							</div>
						</div>
                    </aside>
                </div> 
			</main>     
			
            <script>
                $('.carousel').carousel({
                    interval: 8000
                })s
            </script>
           
			
		</body>
		</html>
`)}

exports.preview =(data,elemts)=>{
    let body= createElemtnts(elemts);
    var myWindow = window.open("", "", "");
    myWindow.document.write(page(data,body));  
}

const seccion = e =>{
    return e.data.code? '<div class="descripcion">'+e.data.code.split('<blockquote>').join('<blockquote class="color-fondo-light p-4 my-4 text-justify font-italic">')+'</div>': '' ;
}
const galeria  = e =>{
    var code='';
    
    e.data.list.map((item,i)=>{
        if(item.active){
            code+=`
            <div class="item mx-auto box-shadow-img carousel-item${i==0?' active':''}">
                <div class="mx-auto bg-white d-flex justify-content-center">
                    <img style="margin: auto" class=" mx-auto" src="${item.image.base}" alt="First slide" />
                </div>
                <div class=" descripcion">
                    <p class="text-dark p-3 color-fondo-light">${item.des}</p>
                </div>
            </div>
            `
        }
    })

    let fo='';
    e.data.list.map((item,i)=>{
        if(item.active){
            fo+=`
            <li data-target="#carouselExampleCaptions${e.order}" data-slide-to="${i}" ${i==0?'class="active"':''}></li>
            `
        }
    })
    
    if(code!='')
        return `
        <div class="row justify-content-center mb-3 ">
            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">
            <div class="carouselPost my-5 w-75 color-fondo-light">
                <div id="carouselExampleCaptions${e.order}" class="box-shadow-img carousel slide" data-ride="carousel">
                    <ol class="carousel-indicators">
                        ${fo}
                    </ol>
                    <div class="box-shadow-img slider-for2 carousel-inner">
                        ${code}
                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleCaptions${e.order}" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleCaptions${e.order}" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>

            <script src="https://code.jquery.com/jquery-3.2.1.slim.min.js" integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN" crossorigin="anonymous"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script>
            <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script>
        </div>`;
    else
        return '';
}
const video = e =>{
    console.log('VIDEO ',e);
    let code=e.data.code;
    if(code && code!='')
        return `
        <div class="row justify-content-center my-5">
            <div class="embed-responsive embed-responsive-16by9 bg-dark text-white w-50">
                <iframe class="embed-responsive-item" src="${e.data.code?e.data.code:''}"></iframe>
            </div>
        </div>`;
    else
        return '';
}

const options = [
    {key:0,code:seccion},
    {key:1,code:galeria},
    {key:2,code:video}
]

const createElemtnts = (elemts) =>{
    var body=''
    elemts.map(e=>{
        body+=options[e.key].code(e);
    })

    return body;
}